import React from 'react';
import { translate } from 'Shared/translate';
import classnames from 'classnames';
import * as styles from './base.scss';
export default class Grade extends React.Component {
    onClick(grade) {
        if (this.canVote) {
            return this.props.onClick(grade);
        }
    }
    render() {
        this.canVote = !!this.props.onClick && (!this.props.uservoted || this.props.uservoted <= 0);
        let arr = new Array(5);
        for (let i = 1; i <= 5; i++) {
            arr[i - 1] = this.props.grade >= i;
        }
        return (React.createElement("div", { className: styles.scorePoints },
            arr.map((fill, i) => (React.createElement("span", { key: i, className: classnames(fill ? styles.fill : styles.empty, this.canVote && styles.cursor), onClick: e => this.onClick(i + 1) }, "\u25CF"))),
            React.createElement("br", null),
            React.createElement("span", { className: styles.votes },
                "(",
                this.props.votes === 1
                    ? translate('/Recipe/Vote', this.props.votes)
                    : translate('/Recipe/Votes', this.props.votes),
                !!this.props.uservoted && `, ${translate('/Recipe/UserVote', this.props.uservoted)}`,
                ")")));
    }
}
